











import Vue from 'vue'
import XDropdown, {
  OptionEntry,
} from '@/components/atoms/Dropdown/XDropdown.vue'
import { Query } from '@/types/generated/graphql'
import INDUSTRY_LIST_QUERY from '@/graphql/partner/industries.gql'

type Data = {
  industries?: OptionEntry<string>[]
}

type Props = {
  value?: string
  rules?: string | Record<string, boolean>
}

export default Vue.extend<Data, {}, {}, Props>({
  inheritAttrs: false,
  name: 'IndustryPicker',
  components: { XDropdown },
  props: {
    value: {
      type: String,
      required: false,
    },
    rules: {
      type: [String, Object],
      required: false,
    },
    // ...rest (inherit attrs from x-dropdown)
  },
  apollo: {
    industries: {
      query: INDUSTRY_LIST_QUERY,
      update(data: Query) {
        const options: Data['industries'] = data.industries.map((industry) => {
          return {
            value: industry.industryId,
            label: industry.name,
          }
        })

        return options
      },
    },
  },
})
